export default __webpack_public_path__ + "static/media/bio.1a019f71.jpg";